export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_wealth-portal-113/artifacts/esidfjb4_Reliserve%20Wealth%20Logo.png";

export const COMPASS_LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_wealth-portal-113/artifacts/kqdlp35n_Reliserve-Wealth-Compass-Logo.png";
export const COMPASS_LOGO_DARK_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_wealth-portal-113/artifacts/kkc3iwmg_Reliserve-Wealth-Compass-Logo-White.png";
export const COMPASS_ICON_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_wealth-portal-113/artifacts/o9t5wdwl_Reliserve-Wealth-Compass-Icon.png";

export const TAGLINE =
  "Build your wealth. Protect your plan.";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/our-strategy", label: "Our Strategy" },
  { to: "/your-goals", label: "Your Goals" },
  { to: "/why-inflation-matters", label: "Why Inflation Matters" },
  { to: "/resources", label: "Resources" },
  { to: "/journal", label: "Journal" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export const BUSINESS_NAME = "Reliserve Wealth";

export const WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/GtdGWz5Ydj2D5zTn22qVBx?mode=gi_t";

export const BOOK_CONSULTATION_URL =
  "https://reliservepulse.com/book-consultation";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function formatINR(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  // Indian number system formatting
  const rounded = Math.round(n);
  const str = rounded.toString();
  const negative = rounded < 0;
  const absStr = negative ? str.slice(1) : str;
  // Group last 3, then groups of 2
  let last3 = absStr.slice(-3);
  const rest = absStr.slice(0, -3);
  const restFmt = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  const withCommas = rest ? `${restFmt},${last3}` : last3;
  return `${negative ? "-" : ""}₹${withCommas}`;
}

export function formatCompactINR(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  if (abs >= 1e3) return `₹${(n / 1e3).toFixed(1)} K`;
  return `₹${Math.round(n)}`;
}
